import { Controller } from "@hotwired/stimulus";
import { useMutation, useResize } from "stimulus-use";

export default class extends Controller {
  /*
  This is almost a random number. The idea is that this amount of scroll away from bottom
  will be treated as if the container is scrolled all the way to the bottom. It's particularly
  useful for small resizes or users who're not careful enough to scroll all the way.
  */
  #bottomScrollLimit = 100;

  autoScroll(): void {
    const isCurrentlyAtBottom =
      Math.abs(
        this.element.scrollTop -
          (this.element.scrollHeight - this.element.clientHeight),
      ) < this.#bottomScrollLimit;

    if (isCurrentlyAtBottom) {
      this.forceAutoScroll();
    }
  }

  connect(): void {
    useResize(this);
    useMutation(this, { attributes: true, childList: true, subtree: true });
    this.forceAutoScroll();
  }

  forceAutoScroll() {
    this.element.scrollTo({ top: this.element.scrollHeight });
  }

  mutate(): void {
    this.autoScroll();
  }

  resize() {
    this.autoScroll();
  }
}
